/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  SkillSuggestionApprovalItem,
  SkillSuggestionApprovalItem$inboundSchema,
} from "./skillsuggestionapprovalitem.js";

/**
 * Per-item outcomes for the snapshotted open suggestions.
 */
export type ApproveAllSkillSuggestionsResult = {
  /**
   * The outcomes in snapshot order.
   */
  items: Array<SkillSuggestionApprovalItem>;
};

/** @internal */
export const ApproveAllSkillSuggestionsResult$inboundSchema: z.ZodMiniType<
  ApproveAllSkillSuggestionsResult,
  unknown
> = z.object({
  items: z.array(SkillSuggestionApprovalItem$inboundSchema),
});

export function approveAllSkillSuggestionsResultFromJSON(
  jsonString: string,
): SafeParseResult<ApproveAllSkillSuggestionsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ApproveAllSkillSuggestionsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ApproveAllSkillSuggestionsResult' from JSON`,
  );
}
